import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { FullSizeColumn } from '../../../../Components/FlexBox';
import FormTextField from '../../../../Components/Form/FormTextField';
import AppointmentSummary from './AppointmentForm/AppointmentSummary';
import ScheduleFields from './ScheduleFields';
import useScheduleFields from '../../Utils/useScheduleFields';

const RecallForm = function RecallForm({
  isOperator,
  confirmed = false, // when true shows summary
  phoneNumber,
  sectionId,
  wavePeriod,
}) {
  const { reset, getValues } = useFormContext();

  const { date, setDate, timeSlot, setTimeSlot, operators } =
    useScheduleFields(isOperator);

  useEffect(() => {
    if (getValues) {
      reset({
        outbound: true,
        phoneNumber,
        sectionId,
        wavePeriod,
        scheduledOn: getValues('scheduledOn') || null,
        assignee: getValues('assignee') || null,
        notes: getValues('notes') || '',
      });
      setTimeSlot(
        getValues('scheduledOn')
          ? getValues('scheduledOn').toTimeString().substring(0, 5)
          : ''
      );
      setDate(
        getValues('scheduledOn')
          ? new Date(getValues('scheduledOn'))
          : new Date()
      );
    }
  }, [phoneNumber, sectionId, wavePeriod]);

  return confirmed ? (
    <AppointmentSummary />
  ) : (
    <FullSizeColumn gap="16px" sx={{ flexGrow: 1 }}>
      <ScheduleFields
        date={date}
        timeSlot={timeSlot}
        operators={operators}
        onChangeDate={setDate}
        onChangeTimeSlot={setTimeSlot}
      />
      <FormTextField name="notes" multiline rows={3} />
    </FullSizeColumn>
  );
};

export default RecallForm;
